const hostnameRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

export const getTracingURLs = (fullURLs: (string | undefined)[]) => {
  const tracingURLs = fullURLs.map((url: string | undefined) => {
    if (!url) {
      return '';
    }
    const hasHttp = url.startsWith('http://');
    const hasHttps = url.startsWith('https://');
    const isHostname = hostnameRegex.test(url);

    if (!hasHttp && !hasHttps && !isHostname) {
      return '';
    }

    if (!hasHttp && !hasHttps && isHostname) {
      return (url = `https://${url}`);
    }

    const parsedUrl = new URL(url);
    const baseUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}`;
    return `${baseUrl}`;
  });

  return tracingURLs.filter(Boolean);
};
